module.exports = __webpack_public_path__ + "img/icon-support.7ca72b3c.png";